import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ChatbotService, Message } from '../../../base/components/chatbot/chatbot.service';

@Component({
    selector: 'app-launchbot',
    templateUrl: './launchbot.component.html',
    styleUrls: ['./launchbot.component.scss'],
    standalone: false
})
export class LaunchbotComponent implements OnInit {
  messages: Message[] = [];
  public _currentData: any = {};
  config: any;
  resourceDef: any;
  application_key: any;
  application_id: any;
  message: string;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private baseService: BaseService,
    private chatbotService: ChatbotService
  ) { }

  ngOnInit(): void {
    this.chatbotService.conversation.subscribe((val) => {
      this.messages = this.messages.concat(val);
    });

    this.application_id = this.route.snapshot.queryParams['key'];
    if(this.application_id != null)
      {
        this.baseService.get("GET_BY_ID", "id:" + this.application_id, "bot_application", "chatbot").subscribe((result: any) => {
          if (result.errCode == 0) {
            var result_data = result.resource[0];
            if(result_data != undefined){
              this.application_key = result_data.application_key;
              if(this.messages.length == 0){
                this.messages.push(new Message("bot", "Welcome! How can I assist you today?"));
              }
            }
          }
        })
      }
    
    }

  backToBotApplication(){
    this.router.navigateByUrl(this.route.snapshot.queryParams['returnUrl']);
  }

  send(){
    this.chatbotService.getChatBotAnswer(this.message, this.application_id, this.application_key);
    this.message = '';
  }
}
